import { WidgetSkeleton } from '@src/components';
import { LocationData } from '@src/services/dashboard/simLocations/simLocationsApiSliceTypes';
import { useTheme } from '@src/theme';
import { Progress } from 'antd';
import { useTranslation } from 'react-i18next';

type TopCountriesProps = {
    countryList?: LocationData[];
    loading?: boolean;
    limit?: number;
};

export function TopCountries({
    countryList,
    loading,
    limit = countryList?.length,
}: TopCountriesProps) {
    const { theme } = useTheme();
    const { t } = useTranslation();
    const topCountries = countryList
        ? [...countryList].sort((a, b) => b.total - a.total).slice(0, limit)
        : [];

    if (loading) {
        return (
            <WidgetSkeleton title={t('pages.dashboard.widgets.topCountries')} />
        );
    }

    return (
        <div
            className="w-full"
            style={{
                color: theme.semantic.textPrimary,
            }}
        >
            <h3 className="mb-4 text-base font-semibold text-deep-navy">
                {t('pages.dashboard.widgets.topCountries')}
            </h3>
            <div
                className="rounded-xl px-2 py-4"
                style={{
                    backgroundColor: theme.semantic.surface,
                }}
            >
                <div
                    className="overflow-y-auto space-y-4"
                    style={{
                        maxHeight: '300px',
                    }}
                >
                    {topCountries?.map((country) => (
                        <div
                            key={country.countryId}
                            className="flex gap-4 items-center"
                        >
                            <img
                                src={country.countryFlag}
                                alt={country.countryName}
                                className="w-8 h-6 rounded-sm"
                            />
                            <div className="flex flex-col w-full">
                                <span className="text-R-12">
                                    {country.countryName}
                                </span>
                                <div className="flex items-center gap-3 w-full">
                                    <Progress
                                        percent={country.total}
                                        showInfo={false}
                                        size={['98%', 8]}
                                        strokeColor={'#233AC6'}
                                    />
                                    <span className="text-R-12 leading-none pr-2 pt-1">
                                        {country.total}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
